import doc                 from '@widesk-core/decorators/doc';
import AbstractPlaceModel  from './AbstractPlaceModel';
import { Translatable }    from '@widesk-core/decorators/translatable';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import appStore            from '@/stores/appStore';
import { computed }        from 'mobx';

@doc.urnResource('place')
@doc.translatable({ title: true, excerpt: true, content: true, localisation: true })
class PlaceModel extends AbstractPlaceModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & PlaceNameProps) {
		return super.renderName(props);
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}/espaces/`;
	}

	getUrl(complete = false) {
		const path = PlaceModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	get status() {
		return this.placeStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}
}

interface PlaceModel
	extends Translatable<{ excerpt: true, title: true, content: true, localisation: true }> {
}

export default PlaceModel;
